var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18 5.41503L11.5 3.12091L5 5.41503V10.8184C5 13.4178 6.26292 15.8552 8.38653 17.3542L11.5 19.5519L14.6135 17.3542C16.7371 15.8552 18 13.4178 18 10.8184V5.41503ZM11.5 22L15.7668 18.9881C18.4213 17.1143 20 14.0677 20 10.8184V4L11.5 1L3 4V10.8184C3 14.0677 4.57865 17.1143 7.23317 18.9881L11.5 22Z",
    fill: "white",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.019e880898618122cd8a126e2996bf1f.svg";
export { ForwardRef as ReactComponent };